import { Component, OnInit, AfterViewInit, ElementRef, inject } from '@angular/core';
import { AuthenticationService } from 'app/core/services/authentication.service';
import { ClientsService } from 'app/core/services/clients.service';
import { Client } from 'app/core/models/client.model';
import { UserRoleName } from 'app/core/enums/user-role-name.enum';
import { DecimalPipe } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ClientListComponent } from '../../components/client-list/client-list.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-capture-admin-clients',
    templateUrl: './capture-admin-clients.component.html',
    imports: [RouterLink, RouterLinkActive, ClientListComponent, MatProgressSpinner, DecimalPipe]
})
export class CaptureAdminClientsComponent implements OnInit, AfterViewInit {
  private clientsService = inject(ClientsService);
  private authService = inject(AuthenticationService);
  private element = inject(ElementRef);

  clients: Client[] = [];
  loading = true;
  canManageClients = false;
  canManageClientConfigurations = false;

  ngOnInit() {
    this.canManageClients = this.authService.hasPermissionTo(UserRoleName.manageClients);
    this.canManageClientConfigurations = this.authService.hasPermissionTo(UserRoleName.manageClientConfigurations);
    this.loadClients();
  }

  // Since we sprinkle a bit of bootstrap and non-bootstrap css,
  // the width of the row that display header and add new client
  // get expanded to where the button no longer appears on the
  // screen. Resetting the row width to the bounding client width
  // was the easiest fix.
  ngAfterViewInit() {
    const row = this.element.nativeElement.querySelector('.row');
    row.style.width = row.getBoundingClientRect().width + 'px';
  }

  private loadClients() {
    this.loading = true;

    this.clientsService.getList().subscribe(result => {
      this.clients = result.clients;
      this.loading = false;
    });
  }
}
